import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import VerificationPhone from "../VerificationPhone/VerificationPhone";
import { useForm } from "react-hook-form";
import { api_register } from "../../api/auth";
import { send_mail } from "../../api/mail";
import Swal from "sweetalert2";
import useFirebase from "../../hooks/useFirebase";


const RegisterPopup = ({ isOpen, onClose, onLoginNowClick }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const { emailRegister } = useFirebase();

  const [showPassword, setShowPassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [emailCodeStatus, setEmailCodeStatus] = useState("active"); // active, sending, sent

  const [otpMatch, setOtpMatch] = useState(false);
  const [otp, setotp] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    country_code: "",
    nric: "",
    phone: "",
    country: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const updateOtpMatch = (value) => {
    setOtpMatch(value);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const _valid = emailRegex.test(email);

    if (_valid) {
      setFormErrors((prevError) => ({
        ...prevError,
        email: "",
      }));
    } else {
      setFormErrors((prevError) => ({
        ...prevError,
        email: "Please put a valid email",
      }));
    }
    return _valid;
  };

  const validatePassword = (password) => {
    // Password must be at least 8 characters, and include at least one lowercase letter, one uppercase letter, one special character, and one number
    const passwordPattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    const _valid = passwordPattern.test(password);
    if (_valid) {
      setFormErrors((prevError) => ({
        ...prevError,
        password: "",
      }));
    } else {
      setFormErrors((prevError) => ({
        ...prevError,
        password:
          "Password must be at least 8 characters, and include at least one lowercase letter, one uppercase letter, one special character, and one number.",
      }));
    }
    return _valid;
  };

  const handleNric = (e) => {
    const inputValue = e.target.value;
    // const numericValue = inputValue.replace(/[^\d-]/g, "");
    const sanitizedValue = inputValue.replace(/-/g, "");

    if (sanitizedValue.length !== 12) {
      // might be passport

      // setFormErrors({
      //   ...formErrors,
      //   nric: "Please put a valid IC numbers",
      // });
    } else {
      setFormErrors({
        ...formErrors,
        nric: "",
      });
    }

    setFormData({
      ...formData,
      nric: sanitizedValue,
    });
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,
      ...data,
    };
    if (otpMatch && validatePassword(updatedFormData.password)) {
      try {
        setIsLoading(true);
        // handle_register(updatedFormData);
        handle_register_firebase(updatedFormData); // firebase
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      if (!otpMatch) {
        Swal.fire({
          icon: "error",
          title: "Register",
          text: "Please verify OTP first",
        });
      }
    }
  };

  const handle_register = async (fromdata) => {
    return await api_register(fromdata)
      .then((data) => {
        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Register",
            text: "Register successfully!",
            iconColor: "#39B5B2", // for success
          }).then((result) => {
            if (result.isConfirmed) {
              onClose();
            }
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Register",
            text: data.message ?? data.reason,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handle_register_firebase = async (formData) => {

    let isValidData = false;

    await api_register(formData)
      .then((data) => {
        if (data.status == true) {
          isValidData = true;
        } else {
          Swal.fire({
            icon: "error",
            title: "Register",
            text: data.message ?? data.reason,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
    ;

    if (!isValidData) {
      console.log("invalid data");
      return;
    }

    return await emailRegister(formData?.email, formData?.password)
      .then((data) => {
        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Register",
            text: "Register successfully!",
            iconColor: "#39B5B2", // for success
          }).then((result) => {
            if (result.isConfirmed) {
              onClose();
            }
          });
        } else {
          console.log({data})
          let error_message =  data.message ?? data.reason
          if(data?.data?.code == 'auth/email-already-in-use'){
            error_message = 'Email already in use.'
          }
          Swal.fire({
            icon: "error",
            title: "Register",
            text: error_message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePhoneChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      phone: value,
    }));
  };

  const handleSelectedCountryChange = (selectedValue) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      country_code: selectedValue.code,
      country: selectedValue, // this is for <verificationPhone selectedCountry>
    }));
  };

  const handleSubmitAndSaveEmail = async (e) => {
    e.preventDefault();

    const newFormErrors = {};
    // email, password, nric
    if (formData.email === "") {
      newFormErrors.email = "Email is required";
    }

    if (formData.password === "") {
      newFormErrors.password = "Password is required";
    }

    if (formData.nric === "") {
      newFormErrors.nric = "NRIC is required";
    }

    if (formData.phone === "") {
      newFormErrors.phone = "Phone number is required";
    }

    setFormErrors(newFormErrors);

    if (Object.keys(newFormErrors).length === 0) {
      setIsLoading(true);
      setEmailCodeStatus("sending");
      const email = formData.email;
      // send email
      const mailObj = {
        to: email,
        recipient: email,
        subject: "OTP For Registration in KPJ Web",
        body: "",
      };
      const res = await send_mail(mailObj, "otp");
      if (!res.status) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.reason,
        });
        return false;
      }
      // setup otp, and when otpMatch will check this
      setotp(res.data.code);
      setEmailCodeStatus("sent");
    }
  };

  return (
    <div className="RegisterPopupContainer">
      <Dialog open={isOpen} onClose={onClose} className="login-popup-section">
        <DialogContent>
          <div className="two-columns-grid login_web_view">
            <div className="first-coloumn" style={{ padding: "36px" }}>
              <div className="first-coloumn-title">Register </div>
              <form>
                <div className="login-emailpassword-group">
                  <div className="textbox-email">
                    <div>
                      <label htmlFor="email">Email</label>
                    </div>

                    <div className="d-flex justify-content-between">
                      <input
                        id="email"
                        type="text"
                        placeholder="Type your email"
                        value={formData.email}
                        onChange={(e) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            email: e.target.value,
                          }));
                          validateEmail(e.target.value);
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                    {formErrors?.email && (
                      <p
                        style={{
                          fontSize: "12px",
                          color: "red",
                          marginTop: "3px",
                          marginBottom: "0",
                          width: "100%",
                          lineHeight: "15px",
                          opacity: formErrors.email ? 1 : 0,
                          transition: "opacity 0.5s ease",
                          transitionDelay: "1s",
                        }}
                      >
                        *{formErrors?.email}
                      </p>
                    )}
                  </div>
                  <div className="textbox-password">
                    <div>
                      <label htmlFor="password">Password</label>
                    </div>
                    <div className="passwordinput">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        value={formData.password}
                        placeholder="Type your password"
                        onChange={(e) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            password: e.target.value,
                          }));
                          validatePassword(e.target.value);
                        }}
                        style={{ width: "100%" }}
                      />

                      <div onClick={togglePasswordVisibility}>
                        {showPassword ? (
                          <i className="fas fa-eye"></i>
                        ) : (
                          <i className="fas fa-eye-slash"></i>
                        )}
                      </div>
                    </div>
                    {formErrors?.password && (
                      <p
                        style={{
                          fontSize: "12px",
                          color: "red",
                          marginTop: "3px",
                          marginBottom: "0",
                          width: "100%",
                          lineHeight: "15px",
                          opacity: formErrors.password ? 1 : 0,
                          transition: "opacity 0.5s ease",
                          transitionDelay: "1s",
                        }}
                      >
                        *{formErrors?.password}
                      </p>
                    )}
                  </div>
                  <div className="textbox">
                    <div>
                      <label htmlFor="nric">NRIC/ Passport no.</label>
                    </div>

                    <input
                      id="nric"
                      type="text"
                      maxLength={12}
                      placeholder="Type your NRIC"
                      style={{ width: "100%" }}
                      value={formData.nric}
                      onChange={handleNric}
                    />
                    {formErrors?.nric && (
                      <p
                        style={{
                          fontSize: "12px",
                          color: "red",
                          marginTop: "3px",
                          marginBottom: "0",
                          width: "100%",
                          lineHeight: "15px",
                          opacity: formErrors.nric ? 1 : 0,
                          transition: "opacity 0.5s ease",
                          transitionDelay: "1s",
                        }}
                      >
                        *{formErrors?.nric}
                      </p>
                    )}
                  </div>
                  <div
                    className="verificationComponent"
                    style={{ position: "relative" }}
                  >
                    <div className="row">
                      <div className="col-xl-12 col-lg-12 col-md-12">
                        <VerificationPhone
                          onSelectedValueChange={handleSelectedCountryChange}
                          handlePhoneChange={handlePhoneChange}
                          updateOtpMatch={updateOtpMatch}
                          phone={formData.phone}
                          otp={otp}
                          selectedCountry={formData.country}
                          handleSubmitAndSaveEmail={handleSubmitAndSaveEmail}
                          emailCodeStatus={emailCodeStatus}
                          formErrorMessage={formErrors.phone}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="login-group">
                  <div className="login-button">
                    <button
                      type="button"
                      color="primary"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Register
                    </button>
                  </div>
                  <div className="login-des">
                    Already have an account?{" "}
                    <span
                      style={{ fontWeight: "500", cursor: "pointer" }}
                      onClick={onLoginNowClick}
                    >
                      Log in
                    </span>
                  </div>
                </div>
              </form>
            </div>
            <div className="second-coloumn web">
              <img
                src="/img/homepage/register-thumbnail.png"
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
              <IconButton
                aria-label="close"
                onClick={onClose}
                style={{ position: "absolute", top: "8px", right: "8px" }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          {/* mobile view */}
          <div className="login_mob_view">
            <div
              style={{
                backgroundImage:
                  'url("/img/bg/register-banner-mobile.png")',
                backgroundSize: "cover",
                height: "245px",
                backgroundRepeat: "no-repeat",
                display: "flex",
                alignItems: "end",
                justifyContent: "flex-end",
                position: "relative",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  fontSize: "25px",
                  fontWeight: "400",
                  color: "white",
                  padding: "28px",
                }}
              >
                <span
                  style={{
                    fontSize: "25px",
                    fontWeight: "700",
                    color: "white",
                    lineHeight: "30.52px",
                  }}
                >
                  Extraordinary Care
                  <br />
                </span>
                Is Right Here
              </p>
              <IconButton
                aria-label="close"
                onClick={onClose}
                style={{ position: "absolute", top: "8px", right: "8px" }}
              >
                <CloseIcon style={{ color: "white" }} />
              </IconButton>{" "}
            </div>
            <div
              className="container"
              style={{ padding: "24px", textAlign: "center" }}
            >
              <p
                style={{
                  fontWeight: "700",
                  fontSize: "25px",
                  color: "black",
                  marginBottom: "20px",
                }}
              >
                Register
              </p>
              <form>
                <div className="login-emailpassword-group">
                  <div
                    style={{
                      border: "none",
                      background: "white",
                      width: "100%",
                      padding: "8px",
                      borderRadius: "10px",
                      textAlign: "left",
                      marginBottom: "8px",
                    }}
                  >
                    <label htmlFor="email" style={{ color: "black" }}>
                      Email
                    </label>
                    <div className="d-flex justify-content-between">
                      <input
                        required
                        id="email"
                        type="text"
                        placeholder="Type your email"
                        value={formData.email}
                        onChange={(e) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            email: e.target.value,
                          }));
                        }}
                        style={{
                          width: "-webkit-fill-available",
                          border: "none",
                        }}
                      />
                    </div>
                    {formErrors?.email && (
                      <p
                        style={{
                          fontSize: "12px",
                          lineHeight: "10px",
                          color: "red",
                          marginTop: "3px",
                          marginBottom: "0",
                          width: "290px",
                        }}
                      >
                        *{formErrors?.email}
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      border: "none",
                      background: "white",
                      width: "100%",
                      padding: "8px",
                      borderRadius: "10px",
                      textAlign: "left",
                      position: "relative",
                      marginBottom: "8px",
                    }}
                  >
                    <label htmlFor="password" style={{ color: "black" }}>
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      placeholder="Enter Here"
                      value={formData.password}
                      onChange={(e) => {
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          password: e.target.value,
                        }));
                      }}
                      style={{
                        width: "-webkit-fill-available",
                        border: "none",
                      }}
                    />

                    <div
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        right: "16px",
                        bottom: "16px",
                      }}
                    >
                      {showPassword ? (
                        <i className="fas fa-eye"></i>
                      ) : (
                        <i className="fas fa-eye-slash"></i>
                      )}
                    </div>
                    {formErrors?.password && (
                      <p
                        style={{
                          fontSize: "12px",
                          lineHeight: "10px",
                          color: "red",
                          marginTop: "3px",
                          marginBottom: "0",
                          width: "290px",
                        }}
                      >
                        *{formErrors?.password}
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      border: "none",
                      background: "white",
                      width: "100%",
                      padding: "8px",
                      borderRadius: "10px",
                      textAlign: "left",
                      position: "relative",
                      marginBottom: "8px",
                    }}
                  >
                    <label htmlFor="nric" style={{ color: "black" }}>
                    NRIC/ Passport no.
                    </label>
                    <input
                      required
                      id="nric"
                      type="text"
                      maxLength={12}
                      placeholder="Type your NRIC"
                      value={formData.nric}
                      onChange={(e) => {
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          nric: e.target.value,
                        }));
                      }}
                      style={{
                        width: "-webkit-fill-available",
                        border: "none",
                      }}
                    />
                    {formErrors?.nric && (
                      <p
                        style={{
                          fontSize: "12px",
                          lineHeight: "10px",
                          color: "red",
                          marginTop: "3px",
                          marginBottom: "0",
                          width: "290px",
                        }}
                      >
                        *{formErrors?.nric}
                      </p>
                    )}
                  </div>
                  <div
                    className="verificationComponent"
                    style={{ position: "relative" }}
                  >
                    <div className="row">
                      <div className="col-xl-12 col-lg-12 col-md-12">
                        <VerificationPhone
                          onSelectedValueChange={handleSelectedCountryChange}
                          handlePhoneChange={handlePhoneChange}
                          updateOtpMatch={updateOtpMatch}
                          phone={formData.phone}
                          otp={otp}
                          selectedCountry={formData.country}
                          handleSubmitAndSaveEmail={handleSubmitAndSaveEmail}
                          emailCodeStatus={emailCodeStatus}
                          formErrorMessage={formErrors.phone}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="login-group">
                  <div className="login-button">
                    <Button
                      onClick={handleSubmit(onSubmit)}
                      style={{
                        background: "#967F65",
                        color: "white",
                        width: "100%",
                        borderRadius: "99px",
                        textTransform: "capitalize",
                        fontSize: "17px",
                        fontWeight: "700",
                      }}
                    >
                      Register
                    </Button>
                  </div>
                  <div style={{ marginTop: "12px" }}>
                    <p
                      style={{
                        marginBottom: "0",
                        fontSize: "13px",
                        lineHeight: "15.51px",
                        color: "#606060",
                      }}
                    >
                      Already have an account?
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        cursor: "pointer",
                        color: "#967F65",
                        fontSize: "13px",
                        lineHeight: "15.87px",
                      }}
                      onClick={onLoginNowClick}
                    >
                      Login
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default RegisterPopup;
